import { ProValueEnum } from '../components/ProTable/interface'
import { GenericalRecord } from '../types/utilities'

/**
 * 把 xxEnumTextMap 转换成 select options
 */
export const mapStringEnumOptions = (map: GenericalRecord) => {
  return Object.keys(map).map(key => ({
    label: map[key],
    value: key
  }))
}

/**
 * 把 xxEnumTextMap 转换成 select options
 */
export const mapNumberEnumOptions = (map: GenericalRecord) => {
  return Object.keys(map).map(key => ({
    label: map[key],
    value: Number.parseInt(key)
  }))
}

/**
 * 把 xxEnumTextMap 转换成 ProTable 的 valueEnum
 */
export const mapProValueEnum = (
  textMap: GenericalRecord,
  colorMap?: GenericalRecord,
  tag = true
) => {
  return Object.keys(textMap).reduce((initialValue, key) => {
    initialValue[key] = {
      tag,
      text: textMap[key],
      color: colorMap?.[key]
    }
    return initialValue
  }, {} as ProValueEnum)
}
